import { defineStore } from 'pinia'

// 状态类型常量定义
const STATUS_TYPE = {
  // 跟进状态
  FOLLOW_UP: 'followUp',
  // 回访状态
  VISIT: 'visit',
  // 诊前沟通状态
  PRE_DIAGNOSIS: 'preDiagnosis'
}

// 操作类型常量定义
const MODIFY_TYPE = {
  ADD: 1,
  EDIT: 2
}

export const todayTodoStore = defineStore('todayTodo', {
  // 其他配置...
  state: () => ({
    // 当前跟进对象
    currentFollowUp: {},
    // 当前回访对象
    currentVisit: {},
    // 当前诊前沟通对象
    currentPreDiagnosis: {}
  }),
  getters: {
    // 获取当前跟进信息
    getCurrentFollowUp: (state) => state.currentFollowUp,
    // 获取当前回访信息
    getCurrentVisit: (state) => state.currentVisit,
    // 获取当前诊前沟通信息
    getCurrentPreDiagnosis: (state) => state.currentPreDiagnosis
  },
  actions: {
    // 设置当前跟进信息
    setCurrentFollowUp(followUpData) {
      this.currentFollowUp = { ...followUpData }
    },
    // 设置当前回访信息
    setCurrentVisit(visitData) {
      this.currentVisit = { ...visitData }
    },
    // 设置当前诊前沟通信息
    setCurrentPreDiagnosis(preDiagnosisData) {
      this.currentPreDiagnosis = { ...preDiagnosisData }
    },
    // 清空当前跟进信息
    clearCurrentFollowUp() {
      this.currentFollowUp = {}
    },
    // 清空当前回访信息
    clearCurrentVisit() {
      this.currentVisit = {}
    },
    // 清空当前诊前沟通信息
    clearCurrentPreDiagnosis() {
      this.currentPreDiagnosis = {}
    },
    // 清空所有当前状态
    clearAllCurrent() {
      this.clearCurrentFollowUp()
      this.clearCurrentVisit()
      this.clearCurrentPreDiagnosis()
    }
  }
})